import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [categories, setCategories] = useState([]);

  const load = () => {
    api.get("/site/settings").then((r) => setSettings(r.data)).catch(() => setSettings({}));
    api.get("/public/categories").then((r) => setCategories(r.data)).catch(() => setCategories([]));
  };

  useEffect(() => { load(); }, []);

  return (
    <SettingsContext.Provider value={{ settings: settings || {}, categories, reload: load }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
